import { render } from "./QTableS.vue?vue&type=template&id=2b1cd024&ts=true"
import script from "./QTableS.ts?vue&type=script&lang=ts&external"
export * from "./QTableS.ts?vue&type=script&lang=ts&external"

import "./QTableS.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable,QSkeleton});
